"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

!function (t, e) {
  for (var i in e) {
    t[i] = e[i];
  }
}(exports, function (t) {
  var e = {};function i(r) {
    if (e[r]) return e[r].exports;var n = e[r] = { i: r, l: !1, exports: {} };return t[r].call(n.exports, n, n.exports, i), n.l = !0, n.exports;
  }return i.m = t, i.c = e, i.d = function (t, e, r) {
    i.o(t, e) || Object.defineProperty(t, e, { enumerable: !0, get: r });
  }, i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t, "__esModule", { value: !0 });
  }, i.t = function (t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t;if (4 & e && "object" == (typeof t === "undefined" ? "undefined" : _typeof(t)) && t && t.__esModule) return t;var r = Object.create(null);if (i.r(r), Object.defineProperty(r, "default", { enumerable: !0, value: t }), 2 & e && "string" != typeof t) for (var n in t) {
      i.d(r, n, function (e) {
        return t[e];
      }.bind(null, n));
    }return r;
  }, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };return i.d(e, "a", e), e;
  }, i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, i.p = "", i(i.s = 84);
}({ 0: function _(t, e) {
    t.exports = function () {
      function _class() {
        _classCallCheck(this, _class);
      }

      _createClass(_class, null, [{
        key: "triggerEvent",
        value: function triggerEvent(t, e) {
          var i = void 0;"function" == typeof Event ? i = new Event(e) : (i = document.createEvent("Event"), i.initEvent(e, !0, !0)), t.dispatchEvent(i);
        }
      }, {
        key: "getElementByAttribute",
        value: function getElementByAttribute(t, e) {
          return e ? document.querySelector("[" + t + "=\"" + e + "\"]") : document.querySelector("[" + t + "]");
        }
      }, {
        key: "getElementsByAttribute",
        value: function getElementsByAttribute(t, e) {
          return e ? document.querySelectorAll("[" + t + "=\"" + e + "\"]") : document.querySelectorAll("[" + t + "]");
        }
      }, {
        key: "getElementByAttributeWithinElement",
        value: function getElementByAttributeWithinElement(t, e, i) {
          return i ? t.querySelector("[" + e + "=\"" + i + "\"]") : t.querySelector("[" + e + "]");
        }
      }, {
        key: "isMouseOver",
        value: function isMouseOver(t) {
          return Array.prototype.slice.call(t.parentElement.querySelectorAll(":hover")).filter(function () {
            return t[0] == this;
          }).length > 0;
        }
      }, {
        key: "getElementsByAttributeWithinElement",
        value: function getElementsByAttributeWithinElement(t, e, i) {
          return i ? t.querySelectorAll("[" + e + "=\"" + i + "\"]") : t.querySelectorAll("[" + e + "]");
        }
      }, {
        key: "getElementByClassWithinElement",
        value: function getElementByClassWithinElement(t, e) {
          return t.querySelector("." + e);
        }
      }, {
        key: "maxWidthMobileViewports",
        value: function maxWidthMobileViewports() {
          return 940;
        }
      }, {
        key: "createEvent",
        value: function createEvent(t) {
          var e = void 0;return "function" == typeof Event ? e = new Event(t) : (e = document.createEvent("Event"), e.initEvent(t, !0, !0)), e;
        }
      }, {
        key: "isDesktop",
        value: function isDesktop() {
          return Math.max(document.documentElement.clientWidth, window.innerWidth || 0) > this.maxWidthMobileViewports();
        }
      }, {
        key: "isIE11",
        value: function isIE11() {
          return -1 !== navigator.userAgent.indexOf("MSIE") || navigator.appVersion.indexOf("Trident/") > -1;
        }
      }, {
        key: "getKeyCodeOnKeyDownEvent",
        value: function getKeyCodeOnKeyDownEvent(t) {
          var e = void 0;if (null != t) if (void 0 === t.code) switch (t.keyCode) {case 13:
              e = "Enter";break;case 38:
              e = "ArrowUp";break;case 40:
              e = "ArrowDown";break;case 8:
              e = "Backspace";break;case 9:
              e = "Tab";break;case 27:
              e = "Escape";break;case 33:
              e = "PageUp";break;case 34:
              e = "PageDown";break;case 32:
              e = "Space";break;default:
              e = void 0;} else e = t.code;return e;
        }
      }, {
        key: "getKeyboardFocusableElements",
        value: function getKeyboardFocusableElements(t) {
          return [].concat(_toConsumableArray(t.querySelectorAll('a[href], button, input, textarea, iframe, select, details,[tabindex]:not([tabindex="-1"])'))).filter(function (t) {
            return !function (t) {
              return "hidden" === window.getComputedStyle(t).visibility;
            }(t) && !t.hasAttribute("disabled") && !t.getAttribute("aria-hidden");
          });
        }
      }]);

      return _class;
    }();
  }, 15: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "GoogleChartsApi", function () {
      return n;
    });var r = !1;
    var n = function () {
      function n() {
        _classCallCheck(this, n);

        this.api = "https://www.gstatic.com/charts/loader.js", this.scriptElement = this.getScriptElement();
      }

      _createClass(n, [{
        key: "load",
        value: function load() {
          var _this = this;

          return new Promise(function (t) {
            !1 === r ? (r = !0, _this.scriptElement = document.createElement("script"), document.body.appendChild(_this.scriptElement), _this.scriptElement.addEventListener("load", function () {
              _this.loadPackages().then(function () {
                t();
              });
            }), _this.scriptElement.async = !0, _this.scriptElement.src = _this.api) : _this.scriptElement.addEventListener("load", function () {
              _this.loadPackages().then(function () {
                t();
              });
            });
          });
        }
      }, {
        key: "loadPackages",
        value: function loadPackages() {
          return google.charts.load("current", { packages: ["corechart", "bar"] });
        }
      }, {
        key: "getScriptElement",
        value: function getScriptElement() {
          return document.querySelector("script[src='" + this.api + "']");
        }
      }]);

      return n;
    }();
  }, 84: function _(t, e, i) {
    t.exports = i(85);
  }, 85: function _(t, e, i) {
    "use strict";
    i.r(e), i.d(e, "Charts", function () {
      return a;
    });var r = i(0),
        n = i.n(r),
        s = i(15);
    var a = function () {
      function a(t) {
        _classCallCheck(this, a);

        this.element = t, this.type = this.getType(), this.addEventHandlers(), this.initializeChart();
      }

      _createClass(a, [{
        key: "addEventHandlers",
        value: function addEventHandlers() {
          var _this2 = this;

          window.addEventListener("resize", function () {
            _this2.createChart();
          });
        }
      }, {
        key: "getType",
        value: function getType() {
          var t = null;var e = this.element.getAttribute("data-rs-charts");if ("string" == typeof e && void 0 !== this.types[e.toLowerCase()] && (t = this.types[e.toLowerCase()]), null === t) throw Error("Chart type is invalid");return t;
        }
      }, {
        key: "initializeChart",
        value: function initializeChart() {
          var _this3 = this;

          this.chartElement = n.a.getElementByAttributeWithinElement(this.element, this.attributes.placeholder);new s.GoogleChartsApi().load().then(function () {
            _this3.createChart(), _this3.createLegend();
          }).catch(function (t) {
            console.error(t);
          });
        }
      }, {
        key: "createChart",
        value: function createChart() {
          var t = n.a.getElementByAttributeWithinElement(this.element, this.attributes.source),
              e = this.element.getAttribute(this.attributes.horizAxisLabel),
              i = this.element.getAttribute(this.attributes.vertAxisLabel),
              r = this.element.getAttribute(this.attributes.valueLabel);switch (this.type) {case this.types.column:
              this.chart = new google.visualization.ColumnChart(this.chartElement), this.options = this.getColumnOptions(e, i, "none" === r || !r, "percentage" === r), this.data = this.getData(t, "percentage" === r), this.chart.draw(this.data, this.options);break;case this.types.donut:
              this.options = this.getDonutOptions(r), this.data = this.getData(t), this.drawDonut(this.data, this.options, this.chartElement);break;case this.types.line:
              this.chart = new google.visualization.LineChart(this.chartElement), this.options = this.getLineOptions(e, i, "none" === r), this.data = this.getData(t), this.chart.draw(this.data, this.options);}this.options.adjustLegendPosition = !!e;
        }
      }, {
        key: "getData",
        value: function getData(t, e) {
          return this.sourceData = this.parseData(t, e), google.visualization.arrayToDataTable(this.sourceData);
        }
      }, {
        key: "parseData",
        value: function parseData(t, e) {
          var _this4 = this;

          var i = [];var r = [].concat(_toConsumableArray(t.querySelectorAll("thead th"))).map(function (t) {
            return t.innerText;
          });this.type !== this.types.line && r.push({ type: "string", role: "style" }), i.push(r);var n = [].concat(_toConsumableArray(t.querySelectorAll("tbody tr"))),
              s = 0;if (e) {
            var _t = function _t(t) {
              return parseFloat([].concat(_toConsumableArray(t.querySelectorAll("td")))[1].innerText);
            };s = n.reduce(function (e, i) {
              return e + _t(i);
            }, s);
          }return n.forEach(function (t, r) {
            var n = [].concat(_toConsumableArray(t.querySelectorAll("td"))).map(function (t, e) {
              return 0 === e ? t.innerText : parseFloat(t.innerText);
            });e && (n[1] = n[1] / (s || 1)), _this4.type !== _this4.types.line && n.push("color: " + _this4.options.colors[r]), i.push(n);
          }), i;
        }
      }, {
        key: "getDefaultOptions",
        value: function getDefaultOptions() {
          return { backgroundColor: "transparent", colors: ["#f0f0f0", "#e8e8e8", "#e0e0e0", "#dcdcdc", "#d8d8d8", "#d3d3d3", "#d0d0d0", "#c8c8c8", "#c0c0c0", "#bebebe", "#b8b8b8", "#b0b0b0", "#a9a9a9", "#a8a8a8", "#a0a0a0"], fontSize: 18, legend: { position: "none" }, tooltip: { textStyle: { color: "#000000", bold: !1 }, isHtml: !1, trigger: "selection" }, animation: { duration: 1e3, easing: "in", startup: !0 } };
        }
      }, {
        key: "getColumnOptions",
        value: function getColumnOptions(t, e, i, r) {
          var n = this.getDefaultOptions();var s = this.chartElement.offsetWidth,
              a = this.chartElement.offsetHeight;return n.chartArea = { width: s - 80, left: 80, top: 20, height: a - 100 }, n.hAxis = i ? { textPosition: "none" } : {}, n.vAxis = i ? { textPosition: "none" } : {}, t && (n.hAxis.title = t), e && (n.vAxis.title = e), r && (n.vAxis.format = "percent"), n;
        }
      }, {
        key: "getDonutOptions",
        value: function getDonutOptions(t) {
          var e = this.getDefaultOptions();var i = this.chartElement.offsetWidth;return e.chartArea = { width: i, left: 0, top: 0, height: i }, e.height = i + 70, e.width = i, e.pieHole = .5, e.pieSliceBorderColor = "white", e.pieSliceText = t || "percentage", e;
        }
      }, {
        key: "drawDonut",
        value: function drawDonut(t, e, i) {
          new google.visualization.PieChart(i).draw(t, e);
        }
      }, {
        key: "getLineOptions",
        value: function getLineOptions(t, e, i) {
          var r = this.getDefaultOptions();var n = this.chartElement.offsetWidth,
              s = this.chartElement.offsetHeight;return r.chartArea = { width: n - 50, left: 50, top: 20, height: s - 130 }, r.curveType = "function", r.hAxis = i ? { textPosition: "none" } : {}, r.vAxis = i ? { textPosition: "none" } : {}, t && (r.hAxis.title = t), e && (r.vAxis.title = e), r;
        }
      }, {
        key: "createLegend",
        value: function createLegend() {
          var t = n.a.getElementByAttributeWithinElement(this.element, this.attributes.legend),
              e = t.parentNode;switch (this.type) {case this.types.donut:case this.types.column:
              this.createDonutOrColumnLegend(t), e.style.marginTop = this.options.adjustLegendPosition ? "15px" : "10px";break;case this.types.line:
              this.createLineLegend(t), this.options.adjustLegendPosition && (e.style.marginTop = "-10px");}
        }
      }, {
        key: "createDonutOrColumnLegend",
        value: function createDonutOrColumnLegend(t) {
          var _this5 = this;

          this.sourceData.shift(), this.sourceData.forEach(function (e, i) {
            null !== t && _this5.appendListItemsToList(i, t, e[0]);
          });
        }
      }, {
        key: "createLineLegend",
        value: function createLineLegend(t) {
          var _this6 = this;

          this.sourceData[0].shift(), this.sourceData[0].forEach(function (e, i) {
            null !== t && _this6.appendListItemsToList(i, t, e);
          });
        }
      }, {
        key: "appendListItemsToList",
        value: function appendListItemsToList(t, e, i) {
          var r = document.createElement("li");r.setAttribute(this.attributes.legendItem, this.options.colors[t]);var n = document.createTextNode(i);r.appendChild(n), e.appendChild(r);
        }
      }, {
        key: "types",
        get: function get() {
          return { column: "column", donut: "donut", line: "line" };
        }
      }, {
        key: "attributes",
        get: function get() {
          return { placeholder: "data-rs-charts-placeholder", source: "data-rs-charts-source", legend: "data-rs-charts-legend", legendItem: "data-rs-charts-legend-item", horizAxisLabel: "data-rs-charts-horiz-axis-label", vertAxisLabel: "data-rs-charts-vert-axis-label", valueLabel: "data-rs-charts-value-label" };
        }
      }], [{
        key: "getSelector",
        value: function getSelector() {
          return "[data-rs-charts]";
        }
      }]);

      return a;
    }();
  } }));